import React from 'react';
import './LatestRequestDetail.css'; // Create a CSS file for styling
import { useLocation } from 'react-router-dom';

function LatestRequestDetail() {
    const location = useLocation();
    const { data } = location.state;  
    return (
        <div className="request-detail-container">
            <h1 className="request-title">{data.title}</h1>
            <div className="request-info">
                <div className="info-row"><strong>Area:</strong> {data.Area}</div>
                <div className="info-row"><strong>Created Date:</strong> {data.CreatedDate}</div>
                <div className="info-row"><strong>Description:</strong> {data.Description}</div>
                <div className="info-row"><strong>District:</strong> {data.District}</div>
                <div className="info-row"><strong>Number of Rooms:</strong> {data.NumberOfRooms}</div>
                <div className="info-row"><strong>Price:</strong> {data.Price}</div>
                <div className="info-row"><strong>Property Status:</strong> {data.PropertyStatus}</div>
                <div className="info-row"><strong>Property Type:</strong> {data.PropertyType}</div>
                <div className="info-row"><strong>Payment Method:</strong> {data.payment_method}</div>
                <div className="info-row"><strong>Phone Number:</strong> {data.phoneNumber || 'Not provided'}</div>
                <div className="info-row"><strong>Developer Name:</strong> {data.DeveloperName || 'Not provided'}</div>
                <div className="info-row"><strong>Expiry Date:</strong> {data.expiryDate !== '0000-00-00 00:00:00' ? data.expiryDate : 'No expiry date'}</div>
            </div>
        </div>
    );
}

export default LatestRequestDetail;
